// this file is generated by update_shopify_store_data.py at 2025-12-03 20:29:17.960448
var courses = [];